import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function WhatsAppButton() {
  const phone = "5519974056980";
  const message = encodeURIComponent("Olá! Gostaria de solicitar um serviço de transporte executivo.");
  const url = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg cursor-pointer transition-transform duration-300 hover:scale-110"
      style={{ backgroundColor: "#25D366" }}
      aria-label="Falar no WhatsApp"
    >
      <i className="ri-whatsapp-line text-white text-3xl flex items-center justify-center w-14 h-14"></i>
    </a>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <WhatsAppButton />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
